export const RESET_USERS = "RESET_USERS";
export const RESET_USER = "RESET_USER";
export const RESET_ERROR = "USERS_RESET_ERROR";

export const GET_USERS = "GET_USERS";
export const SET_USERS = "SET_USERS";

export const API_ERROR = "USERS_API_ERROR";

export const GET_USER = "GET_USER";
export const GET_USER_SUMMARY_SETTINGS = "GET_USER_SUMMARY_SETTINGS";
export const SET_USER = "SET_USER";

export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";

export const EDIT_PASSWORD = "EDIT_PASSWORD";
export const EDIT_PASSWORD_SUCCESS = "EDIT_PASSWORD_SUCCESS";

export const CREATE_USER = "CREATE_USER";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";

export const ACTIVATE_USER = "ACTIVATE_USER";
export const ACTIVATE_USER_SUCCESS = "ACTIVATE_USER_SUCCESS";

export const GET_USERS_FORM = "GET_USERS_FORM";
export const SET_USERS_FORM = "SET_USERS_FORM";
